"use client";

import { createContext, useContext } from "react";
import type { ArTableContextValue } from "./types";

export const ArTableContext = createContext<ArTableContextValue | null>(null);

export function useArTableContext(): ArTableContextValue {
  const ctx = useContext(ArTableContext);
  if (!ctx) {
    throw new Error("ArTable sub-components must be used within <ArTable.Root>");
  }
  return ctx;
}
